/**
 * Legacy ImportJobsApiService module — preserved as an AngularJS shell so
 * existing dependencies (`acme.common.service.importJobsApi`) and the
 * `JOB_TYPE` constant injected directly by AJS controllers keep resolving.
 *
 * The actual `ImportJobsApiService` is now an Angular 18 class registered as
 * a downgraded factory under the same name in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 *
 * Implementation:
 *   apps/b2b-frontend/app/core/api/import-jobs/import-jobs-api.service.ts
 *
 * Do NOT register `.provider('ImportJobsApiService', ...)` here — it would
 * shadow the downgraded service.
 */
angular.module('acme.common.service.importJobsApi', []).constant('JOB_TYPE', {
  UNKNOWN: 'UNKNOWN',
  IMPORT: 'IMPORT',
  EXPORT: 'EXPORT',
});
